module.exports = __webpack_public_path__ + "img/Primordial-Process-10.42f82467.png";